import { Coachmark, DirectionalHint } from "@fluentui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

let lastStyle = undefined;
const GlobalCoachMark = (props) => {
  const coachMark = useSelector((state) => state.coachMark);
  const dispatch = useDispatch();
  const [element, setElement] = useState(undefined);

  useEffect(() => {
    let el = document.getElementById(coachMark?.id);
    if (el) {
      setElement(el);
      lastStyle = {
        transition: el.style?.transition,
        boxShadow: el.style?.boxShadow,
      };
      Object.assign(el.style, {
        transition: "all 0.3s linear",
        boxShadow: "0 0 4px 3px #df6362",
      });
    }
  }, [coachMark]);

  return (
    <>
      {element && coachMark?.id ? (
        <Coachmark
          target={element}
          onAnimationOpenEnd={(x) => {
            Object.assign(element?.style, lastStyle);
            dispatch({ type: "set", coachMark: undefined });
          }}
          color='#df6362'
          beaconColorTwo='#b42625'
          beaconColorOne='#ad5d52'
          isPositionForced
          positioningContainerProps={{
            directionalHint: coachMark?.dir
              ? coachMark?.dir
              : DirectionalHint.topLeftEdge,
            doNotLayer: false,
          }}
        ></Coachmark>
      ) : null}
    </>
  );
};

export default GlobalCoachMark;
